import React from 'react';

// TODO Any type. Should be fixed
// eslint-disable-next-line
export type WebsocketContextProps<M = any> = {
  message: M & {instance_id?: string};
  clearMessage: () => void;
  cleanup: () => void;
  connect: () => void;
  send?: (message: M & {instance_id?: string}) => void;
};

export const WebsocketContext = React.createContext<WebsocketContextProps>({
  send: () => {},
  clearMessage: () => {},
  cleanup: () => {},
  connect: () => {},
  message: {event_type: null},
});
